import * as React from "react"
import { Widget, mk_widget, any } from "widgets-for-react"
import { styleguideChapter, styleguideSection, styleguidePart, styleguideExample, styleguideCode } from "../helpers"
import SyntaxHighlighter from 'react-syntax-highlighter';
import { vs, xcode, atomOneDark, darkula, atomOneLight } from "react-syntax-highlighter/styles/hljs";

export const styleguideObjects: Widget<never> = mk_widget ({
  run: _ => (
    styleguideChapter({ type: 'objects', slug: 'objects', title: 'Buttons',})(
      any()([
        styleguideSection({type: 'objects', slug: 'objects-buttons', title: ''})(
          any()([
            styleguidePart({ title: 'Primary button' })(
              any()([
                styleguideExample({ showExampleLabel: true, isFullScreen: false, description: 'This button has a dark and a lightt version to be visible also on colorfull backgrounds'})(
                  mk_widget({
                    run: _ => (
                      <>
                        <button className="button button--primary">View more</button>
                        <br />
                        <br />
                        <button className="button button--primary--inverted">Read more</button>
                      </>
                    )
                  })
                ),
                styleguideCode({})(
                  mk_widget({
                    run: _=> (
                      <SyntaxHighlighter language="html" style={atomOneDark}>
                        &lt;button className=&quot;button button--primary&quot;&gt;View more&lt;/button&gt;
                        &lt;button className=&quot;button button--primary--inverted&quot;&gt;read more&lt;/button&gt;
                      </SyntaxHighlighter>
                    )
                  })
                )
              ])
            ),
            styleguidePart({ title: 'Secondary button' })(
              any()([
                styleguideExample({ showExampleLabel: true, isFullScreen: false})(
                  mk_widget({
                    run: _ => (
                      <>
                        <button className="button button--secondary">Read more</button>
                      </>
                    )
                  })
                ),
                styleguideCode({})(
                  mk_widget({
                    run: _=> (
                      <SyntaxHighlighter language="html" style={atomOneDark}>
                        &lt;button className=&quot;button button--secondary&quot;&gt;Read more&lt;/button&gt;
                      </SyntaxHighlighter>
                    )
                  })
                )
              ])
            )
          ])
        ),
        styleguideSection({type: 'objects', slug: 'objects-links', title: ''})(
          any()([
            styleguidePart({ title: 'Inline link' })(
              any()([
                styleguideExample({ showExampleLabel: true, isFullScreen: false})(
                  mk_widget({
                    run: _ => (
                      <div className="text--styled">
                        <p>We have a great deal of knowledge about milk and <a>its derivative products.</a> We are proud of our <a>innovations.</a></p>
                      </div>
                    )
                  })
                ),
                styleguideCode({})(
                  mk_widget({
                    run: _=> (
                      <SyntaxHighlighter language="html" style={atomOneDark}>
                        &lt;a className=&quot;link link--primary&quot;&gt;Read more&lt;/a&gt;
                      </SyntaxHighlighter>
                    )
                  })
                )
              ])
            ),
            styleguidePart({ title: 'Primary link' })(
              any()([
                styleguideExample({ showExampleLabel: true, isFullScreen: false})(
                  mk_widget({
                    run: _ => (
                      <a className="link link--primary">Read more</a>
                    )
                  })
                ),
                styleguideCode({})(
                  mk_widget({
                    run: _=> (
                      <SyntaxHighlighter language="html" style={atomOneDark}>
                        &lt;a className=&quot;link link--primary&quot;&gt;Read more&lt;/a&gt;
                      </SyntaxHighlighter>
                    )
                  })
                )
              ])
            )
          ])
        ),
        styleguideSection({type: 'objects', slug: 'objects-lists', title: ''})(
          any()([
            styleguidePart({ title: 'Ordered list' })(
              any()([
                styleguideExample({ showExampleLabel: true, isFullScreen: false})(
                  mk_widget({
                    run: _ => (
                      <div className="text--styled">
                        <ol>
                          <li>We have <a>a great deal of knowledge</a> about milk</li>
                          <li>We are proud of our innovations</li>
                          <li>We are seeking active cooperation </li>
                        </ol>
                      </div>
                    )
                  })
                ),
                styleguideCode({})(
                  mk_widget({
                    run: _=> (
                      <SyntaxHighlighter language="html" style={atomOneDark}>
                        &lt;div className=&quot;text--styled&quot;&gt;
                        &#10;&#32;&lt;ol&gt;
                            &#10;&#32;&#32;&lt;li&gt;We have a great deal of knowledge about milk&lt;/li&gt;
                            &#10;&#32;&#32;&lt;li&gt;We are proud of our innovations&lt;/li&gt;
                            &#10;&#32;&#32;&lt;li&gt;We are seeking active cooperation &lt;/li&gt;
                          &#10;&#32;&lt;/ol&gt;
                      &#10;&lt;/div&gt;
                      </SyntaxHighlighter>
                    )
                  })
                )
              ])
            ),
            styleguidePart({ title: 'Unordered list' })(
              any()([
                styleguideExample({ showExampleLabel: true, isFullScreen: false})(
                  mk_widget({
                    run: _ => (
                      <div className="text--styled">
                        <ul>
                          <li>We have a great deal of knowledge about milk</li>
                          <li>We have a great deal of knowledge about milk and its derivative products. We are proud of our innovations.</li>
                          <li>We are seeking active cooperation </li>
                        </ul>
                      </div>
                    )
                  })
                ),
                styleguideCode({})(
                  mk_widget({
                    run: _=> (
                      <SyntaxHighlighter language="html" style={atomOneDark}>
                        &lt;div className=&quot;text--styled&quot;&gt;
                        &#10;&#32;&lt;ul&gt;
                            &#10;&#32;&#32;&lt;li&gt;We have a great deal of knowledge about milk&lt;/li&gt;
                            &#10;&#32;&#32;&lt;li&gt;We have a great deal of knowledge about milk and its derivative products. We are proud of our innovations.&lt;/li&gt;
                            &#10;&#32;&#32;&lt;li&gt;We are seeking active cooperation &lt;/li&gt;
                          &#10;&#32;&lt;/ul&gt;
                      &#10;&lt;/div&gt;
                      </SyntaxHighlighter>
                    )
                  })
                )
              ])
            )
          ])
        ),
      ])
    ).run(_)
  )
})

